import React, { useState } from "react";
import MuiAlert from '@mui/material/Alert';
import { Box, TextField, Button, SvgIcon, Snackbar, IconButton, Stack, InputAdornment } from "@mui/material";
import { Search, Close as CloseIcon } from "@mui/icons-material";
import { AlertSeverity } from "../../../constants/AlertTypes";

interface AddDocumentMappingProps {
  open: boolean;
  addItemFunction: (
    docIndex: number,
    docName: string,
    encDocName: string
  ) => void;
  showSelectItem: () => void;
  encompassDocName: string;
  onClose?: () => void;
}

const AddDocumentMapping: React.FC<AddDocumentMappingProps> = ({
  open,
  addItemFunction,
  showSelectItem,
  encompassDocName,
  onClose
}) => {
  const [docIndex, setDocIndex] = useState(0);
  const [docName, setDocName] = useState("");

  // State Confirmations
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState<AlertSeverity>('info');

  const docIndexChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = e.target;
    var intVal = parseInt(value);
    if (intVal < -999999) {
      intVal = -999999;
    }
    if (intVal > 999999) {
      intVal = 999999;
    }
    setDocIndex(intVal);
  };

  const addItem = () => {
    if (docIndex === 0) {
      openAlert("Docutech Index must not equal 0.", 'error');
      return;
    }
    if (!docName || !docName.trim()) {
      openAlert("Docutech Name must have a value.", 'error');
      return;
    }
    if (!encompassDocName || !encompassDocName.trim()) {
      openAlert("Encompass Document Name must have a value.", 'error');
      return;
    }
    addItemFunction(docIndex, docName, encompassDocName);
    setDocIndex(0);
    setDocName("");
  };

  // Alert Handling 
  const handleSnackBarClose = (_event: any) => { setAlertOpen(false); }
  const openAlert = (message: string, severity: 'success' | 'error' | 'info' | 'warning' = 'info') => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
  }

  return (
    <Stack
     direction='row'
     width="100%"
     spacing={2}
    >
     
        <TextField
          label={"Docutech Index"}
          value={docIndex}
          onChange={docIndexChange}
          type="number"
          name="documentIndex"
          variant="outlined"
          size="small"
          sx={{minWidth: "120px"}}
        />
     
        <TextField
          label={"Docutech Name"}
          value={docName}
          onChange={(e) => setDocName(e.target.value)}
          fullWidth
          name="docutechName"
          variant="outlined"
          size="small"
        />

      <TextField
        label={"Encompass Document Name"}
        value={encompassDocName}
        fullWidth
        name="docutechName"
        variant="outlined"
        size="small"
        inputProps={{ readOnly: true }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={showSelectItem} edge="end">
                <SvgIcon sx={{ color: "#143A6B", cursor: "pointer" }} component={Search} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Stack direction="row" alignItems="center" spacing={0}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>

        <Button onClick={addItem}>Add</Button>
      </Stack>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertOpen}
        autoHideDuration={4000}
        onClose={handleSnackBarClose}
      >
        <MuiAlert
          onClose={handleSnackBarClose}
          severity={alertSeverity}
          sx={{ width: '100%', fontSize: '1.2rem', padding: '12px 16px' }}>
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Stack>
  );
};

export default AddDocumentMapping;